import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dtik0xdswq: FaireBrandEntity = {
  token: "b_dtik0xdswq",
  type: "brand",
  name: "Maggie's Organics",
  avatarUrl:
    "https://cdn.faire.com/fastly/a4bc95d331d86e2942712a150435a0bb8fae493444e78d19365d70502b1402a6.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6c75a2ec15b67420da9bc2cafbcbc86acc5a2b0c143bb947e211ad9966dae641.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a4bc95d331d86e2942712a150435a0bb8fae493444e78d19365d70502b1402a6.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6c75a2ec15b67420da9bc2cafbcbc86acc5a2b0c143bb947e211ad9966dae641.jpeg",
  location: "Dexter, MI, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 61,
  isTopShop: true,
  isInsider: true,
  description:
    "Maggie’s Organics makes timeless clothing and soft goods using techniques that respect people and our planet. We are committed to improving upon even the highest industry standards, reflected by our one-of-a-kind Real Fair Trade pledge which aims for total transparency, total sustainability, and true ethical practices from farm to finish. \n\nOur supply chains are built from the ground up across five continents, relying on ethical practices and regenerative farming techniques to produce truly organic wool and cotton. These resources are turned into production-ready yarn and fabrics using the highest international organic standards and crafted into the Maggie’s products that you know and love. \n\nThe Maggie’s difference isn’t the techniques or the materials — it’s the people. Our long-term partners who make up our global tapestry are integral to our process. We believe that they deserve to be treated with dignity and respect. Our founder Bená Burda had the passion to intertwine this mission into our DNA over thirty years ago and our recent transition to employee ownership safeguards our ability to continue our mission into the next generation. \n\nMaggie’s Organics is dedicated to strengthening the threads that connect us. Let's take the next step together.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:16.443Z",
    importedBy: "entity-db-cli",
  },
};
